import React from 'react'
import { setPropTypes } from '../icons/BaseIcon'

function KiplingerColorLogo({ width = 160, height = 50 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 160 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.58489 39.3814H0.761719V0.665039H8.58489V39.3814ZM8.60592 19.4238L18.7214 0.665039H26.6076L16.2819 18.9191L26.7128 39.4024H18.6583L8.60592 19.4238Z"
        fill="#CC2936"
      />
      <path
        d="M27.8281 39.3818V13.0732H34.9994V39.3818H27.8281Z"
        fill="#CC2936"
      />
      <path
        d="M50.0352 26.1959C50.0352 33.6616 48.3949 34.2083 47.2382 34.2714C46.4601 34.3135 45.703 33.977 45.3665 33.6616V18.7092C45.8502 18.3517 46.6494 18.0993 47.3434 18.0993C48.7103 18.1204 50.0352 18.8143 50.0352 26.1959ZM57.2485 26.0487C57.2485 17.3212 54.9983 12.5264 50.5189 12.5264C48.2266 12.5264 46.5022 13.3886 45.3455 15.071V13.0731H38.1953V49.4341H45.3665V38.2251C46.4391 39.2345 48.2266 39.9285 50.2035 39.9285C54.5777 39.9075 57.2485 35.6594 57.2485 26.0487Z"
        fill="#CC2936"
      />
      <path
        d="M59.9375 39.3813V0.707031H67.1087V39.3603H59.9375V39.3813Z"
        fill="#CC2936"
      />
      <path
        d="M70.3711 39.3818V13.0732H77.5423V39.3818H70.3711Z"
        fill="#CC2936"
      />
      <path
        d="M92.516 39.3815V19.7604C92.516 18.7089 91.4855 18.0991 90.3289 18.0991C89.2984 18.0991 88.5413 18.4356 87.9315 18.772V39.3815H80.7812V13.0729H87.9525V15.1128C89.1933 13.9141 91.2963 12.5682 93.4834 12.5051C96.8482 12.3999 99.6452 13.9141 99.6452 18.2042V39.3815H92.516Z"
        fill="#CC2936"
      />
      <path
        d="M114.155 33.724C113.714 34.0815 112.894 34.3339 112.179 34.3339C110.896 34.3339 109.445 33.6399 109.445 26.2583C109.445 18.7927 111.043 18.1828 112.242 18.1828C113.02 18.1828 113.819 18.4772 114.155 18.7927V33.724ZM121.264 39.4652V13.0725H114.155V14.9652C113.272 13.3249 111.632 12.3785 109.276 12.5257C105.197 12.7571 102.273 16.7738 102.273 26.4056C102.273 35.133 104.755 39.9279 109.234 39.9279C111.59 39.9279 113.02 39.2759 114.155 38.1193V40.2223C114.155 42.9352 111.926 44.6807 105.849 44.4914V49.4334C114.429 50.2536 121.264 47.3304 121.264 39.4652Z"
        fill="#CC2936"
      />
      <path
        d="M135.792 23.5461H130.661C130.829 18.541 131.902 17.5525 133.248 17.5525C134.615 17.5315 135.687 18.8774 135.792 23.5461ZM142.648 28.1307C142.648 27.668 142.648 26.4693 142.648 26.1749C142.648 17.0899 139.157 12.5264 133.374 12.5264C126.876 12.5264 123.742 17.4474 123.742 26.4272C123.742 35.1547 127.275 39.9285 133.037 39.9285C139.557 39.9285 141.891 35.7015 142.48 31.4534H136.129C136.129 34.4607 134.531 34.692 133.584 34.671C132.217 34.6289 130.682 33.977 130.682 28.1517H142.648V28.1307Z"
        fill="#CC2936"
      />
      <path
        d="M159.389 19.5917C158.442 18.9398 156.613 18.6244 155.435 18.6244C154.426 18.6244 152.701 18.9819 151.986 19.5917V39.381H144.836V13.0724H152.007V15.3016C152.701 13.8295 154.762 12.6098 156.508 12.5256C157.854 12.4625 158.59 12.5887 159.431 12.8831V19.5917H159.389Z"
        fill="#CC2936"
      />
      <path
        d="M34.9994 2.81055H27.8281V9.98179H34.9994V2.81055Z"
        fill="#CC2936"
      />
      <path
        d="M77.5423 2.81055H70.3711V9.98179H77.5423V2.81055Z"
        fill="#CC2936"
      />
    </svg>
  )
}

setPropTypes(KiplingerColorLogo)
export default KiplingerColorLogo
